import React from 'react';
import { Link } from 'react-router-dom';
// Swiper 필수 임포트
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../styles/Home.css';
import home1 from '../assets/home1.png';
import home2 from '../assets/home2.png';
import home3 from '../assets/home3.png';
import wj from '../assets/wj.png';
import hw from '../assets/hw.png';
import ys from '../assets/ys.png';
import yl from '../assets/yl.png';
import jh from '../assets/jh.png';

// 상단/하단 통이미지

const SliderAuthor = ({ allIssues }) => {
  // 슬라이더에 들어갈 이미지 배열
  const writerSlideImages = [wj, hw, ys, yl, jh];

  console.log('allissues', allIssues);

  return (
    <div className="home-container">
      {/* 1. 상단 인트로 (통이미지) */}
      {/* 1. 상단 인트로 (통이미지) */}
      <section className="home-section">
        <img src={home1} alt="Intro" className="full-width-img" />
      </section>

      {/* 2. 작가 소개 이미지 슬라이더 섹션 */}
      <section className="home-section writer-slider-bg">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          centeredSlides={true} // 1개가 정확히 가운데 오도록 설정
          slidesPerView={'auto'} // CSS에서 정한 width(600px)를 따름
          spaceBetween={30} // 카드 사이 간격
          loop={true} // 무한 반복
          autoplay={{ delay: 3500, disableOnInteraction: false }}
          className="writer-peek-swiper"
        >
          {writerSlideImages.map((imgSrc, index) => (
            <SwiperSlide key={index} className="writer-note-slide">
              <img src={imgSrc} alt={`작가노트 ${index + 1}`} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      {/* 3. 중간 브릿지 이미지 */}
      <section className="home-section">
        <img src={home2} alt="Bridge" className="full-width-img" />
      </section>

      {/* 4. 지난 이야기 그리드 영역 */}
      <section className="issue-grid-section">
        <div className="issue-grid">
          {allIssues?.map((issue) => (
            <Link key={issue.id} to={`/content/${issue.id}`} className="issue-card">
              <img src={issue.thumbnail} alt={`${issue.id}호`} className="issue-img" />

              {/* 하얀색 블러 레이어 오버레이 */}
              <div className="issue-overlay">
                <div className="overlay-text">
                  <span className="issue-num">{issue.id}호</span>
                  <br />
                  <span className="issue-title">⟪{issue.theme}⟫</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* 5. 하단 푸터 영역 (통이미지) */}
      <section className="home-section">
        <img src={home3} alt="Footer" className="full-width-img" />
      </section>

      
    </div>
  );
};

export default SliderAuthor;
